import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-r-q20',
  templateUrl: './r-q20.component.html',
  styleUrls: ['./r-q20.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' }))
      ])
    ])
  ]
})
export class RQ20Component implements OnInit {

  @Input() data: any;
  question;
  questions;
  user_bot = false;
  userResponses = [];
  index;
  questionObj;
  smart_home_devices = [];
  showTip = false;
  deviceWidth;
  hgHomedevices = {
    device1: false,
    device2: false,
    device3: false,
    device4: false,
    device5: false,
    device6: false
  };
  disable = false;
  time = 0;
  device1_id;
  device2_id;
  device3_id;
  device4_id;
  device5_id;
  device6_id;
  showTyping = false;
  timer;
  typingTimer;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.device1_id = document.getElementById('device1_mob');
      this.device2_id = document.getElementById('device2_mob');
      this.device3_id = document.getElementById('device3_mob');
      this.device4_id = document.getElementById('device4_mob');
      this.device5_id = document.getElementById('device5_mob');
      this.device6_id = document.getElementById('device6_mob');
    } else {
      this.device1_id = document.getElementById('device1');
      this.device2_id = document.getElementById('device2');
      this.device3_id = document.getElementById('device3');
      this.device4_id = document.getElementById('device4');
      this.device5_id = document.getElementById('device5');
      this.device6_id = document.getElementById('device6');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        // If the flow is from renewal -> show 'renewal_question' text
        if (this.residentialService.questionFlowType === 'renewal') {
          this.question = this.questions[i].renewal_question;
        }
        this.index = i;
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'res_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.smart_home_devices = obj.fieldValue;
        if (!_.isEmpty(this.smart_home_devices)) {
          for (let j = 0; j < this.smart_home_devices.length; j++) {
            if ( this.smart_home_devices[j] === 'Smart thermostat (Nest, Ecobee, etc)') {
              this.hgHomedevices.device1 = true;
              this.device1_id.parentElement.classList.add('active-select');
            } else if ( this.smart_home_devices[j] === 'Virtual assistant (Alexa, Siri, Google, etc)') {
              this.hgHomedevices.device2 = true;
              this.device2_id.parentElement.classList.add('active-select');
            } else if ( this.smart_home_devices[j] === 'Smart outlets') {
              this.hgHomedevices.device3 = true;
              this.device3_id.parentElement.classList.add('active-select');
            } else if ( this.smart_home_devices[j] === 'Smart lightbulbs') {
              this.hgHomedevices.device4 = true;
              this.device4_id.parentElement.classList.add('active-select');
            } else if ( this.smart_home_devices[j] === 'Smart light switches') {
              this.hgHomedevices.device5 = true;
              this.device5_id.parentElement.classList.add('active-select');
            } else if ( this.smart_home_devices[j] === 'None of the above') {
              this.hgHomedevices.device6 = true;
              this.device6_id.parentElement.classList.add('active-select');
            }
          }
          this.user_bot = true;
          this.showTip = true;
          if (this.deviceWidth < 768) {
            this.showTyping = true;
            setTimeout(() => {
              this.showTyping = false;
              this.next();
            }, this.time);
          }
        }
      }
    }
  }

  getDevices(device, value) {
    if (this.deviceWidth < 768) {
      this.residentialService.unSelectService({'currentId': this.data});
    }
    if (device !== 'None of the above' && value === true) {
      if (_.contains(this.smart_home_devices, 'None of the above')) {
        this.hgHomedevices.device6  = false;
        const index = this.smart_home_devices.indexOf('None of the above');
        this.smart_home_devices.splice(index, 1);
        if (_.contains(this.device6_id.parentElement.classList, 'active-select')) {
          this.device6_id.parentElement.classList.remove('active-select');
        }
      }
     }
      if (device === 'Smart thermostat (Nest, Ecobee, etc)' && value === true) {
      this.smart_home_devices.push(device);
      this.showTip = true;
      this.device1_id.parentElement.classList.add('active-select');
    } else if (device === 'Smart thermostat (Nest, Ecobee, etc)' && value === false) {
      if (!_.isEmpty(this.smart_home_devices)) {
        const index = this.smart_home_devices.indexOf(device);
        this.smart_home_devices.splice(index, 1);
        this.device1_id.parentElement.classList.remove('active-select');
      }
    } else if (device === 'Virtual assistant (Alexa, Siri, Google, etc)' && value === true) {
      this.smart_home_devices.push(device);
      this.showTip = true;
      this.device2_id.parentElement.classList.add('active-select');
    } else if (device === 'Virtual assistant (Alexa, Siri, Google, etc)' && value === false) {
      if (!_.isEmpty(this.smart_home_devices)) {
        const index = this.smart_home_devices.indexOf(device);
        this.smart_home_devices.splice(index, 1);
        this.device2_id.parentElement.classList.remove('active-select');
      }
    } else if (device === 'Smart outlets' && value === true) {
      this.smart_home_devices.push(device);
      this.showTip = true;
      this.device3_id.parentElement.classList.add('active-select');
    } else if (device === 'Smart outlets' && value === false) {
      if (!_.isEmpty(this.smart_home_devices)) {
        const index = this.smart_home_devices.indexOf(device);
        this.smart_home_devices.splice(index, 1);
        this.device3_id.parentElement.classList.remove('active-select');
      }
    } else if (device === 'Smart lightbulbs' && value === true) {
      this.smart_home_devices.push(device);
      this.showTip = true;
      this.device4_id.parentElement.classList.add('active-select');
    } else if (device === 'Smart lightbulbs' && value === false) {
      if (!_.isEmpty(this.smart_home_devices)) {
        const index = this.smart_home_devices.indexOf(device);
        this.smart_home_devices.splice(index, 1);
        this.device4_id.parentElement.classList.remove('active-select');
      }
    } else if (device === 'Smart light switches' && value === true) {
      this.smart_home_devices.push(device);
      this.showTip = true;
      this.device5_id.parentElement.classList.add('active-select');
    } else if (device === 'Smart light switches' && value === false) {
      if (!_.isEmpty(this.smart_home_devices)) {
        const index = this.smart_home_devices.indexOf(device);
        this.smart_home_devices.splice(index, 1);
        this.device5_id.parentElement.classList.remove('active-select');
      }
    } else if (device === 'None of the above' && value === true) {
      this.smart_home_devices = [];
      this.smart_home_devices.push(device);
      this.showTip = true;
      this.hgHomedevices = {
        device1: false,
        device2: false,
        device3: false,
        device4: false,
        device5: false,
        device6: true
      };
      this.device1_id.parentElement.classList.remove('active-select');
      this.device2_id.parentElement.classList.remove('active-select');
      this.device3_id.parentElement.classList.remove('active-select');
      this.device4_id.parentElement.classList.remove('active-select');
      this.device5_id.parentElement.classList.remove('active-select');
      this.device6_id.parentElement.classList.add('active-select');
      // this.disable = true;
    } else if (device === 'None of the above' && value === false) {
      this.smart_home_devices = [];
      this.hgHomedevices = {
        device1: false,
        device2: false,
        device3: false,
        device4: false,
        device5: false,
        device6: false
      };
      this.device1_id.parentElement.classList.remove('active-select');
      this.device2_id.parentElement.classList.remove('active-select');
      this.device3_id.parentElement.classList.remove('active-select');
      this.device4_id.parentElement.classList.remove('active-select');
      this.device5_id.parentElement.classList.remove('active-select');
      this.device6_id.parentElement.classList.remove('active-select');
    }
    if (_.isEmpty(this.smart_home_devices)) {
      this.showTip = false;
      this.user_bot = false;
    } else {
      this.user_bot = true;
    }
    this.save();
    this.time = 3000;
    this.goNext();
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
this.showTyping = false;
      }
      this.typingTimer = setTimeout(() => {
        this.showTyping = true;
      }, 250);
      this.timer = setTimeout(() => {
        // // console.log.log(this.time);
        this.showTyping = false;
        this.next();
      }, this.time);
    }
  }

  next() {
    if (_.isEmpty(this.smart_home_devices)) {
      // console.log.log('smart_devices_sp:', this.smart_home_devices);
      // alert('Select the Option');
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({'currentId': this.data});
      }
    } else {
      this.residentialService.messageService({ 'currentId': this.data });
    }
  }
  // This function is used for to save the data in DB
  save() {
    const Obj = {
      'res_question_id': this.data,
      'fieldName': 'smart_home_devices_sp',
      'fieldValue': this.smart_home_devices
    };
    this.residentialService.updateResponses(Obj);
  }
}
